"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = __importDefault(require("@mapmaker/config"));
const client_1 = require("../../../client");
function MapmakerImage(_a) {
    var { pmSrc, tblSrc, src } = _a, props = __rest(_a, ["pmSrc", "tblSrc", "src"]);
    const { businessId } = (0, client_1.useMapmakerAppConfig)();
    function getSource() {
        if (tblSrc && businessId === "tbl") {
            return tblSrc;
        }
        else if (pmSrc && businessId === "pm") {
            return pmSrc;
        }
        return src.replace("{businessId}", businessId);
    }
    return (0, jsx_runtime_1.jsx)("img", Object.assign({ src: `${config_1.default.staticUrl}/${getSource()}` }, props));
}
exports.default = MapmakerImage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJJbWFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NoYXJlZC9pbWFnZXMvTWFwbWFrZXJJbWFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQSw4REFBOEM7QUFDOUMsNENBQXVEO0FBVXZELFNBQXdCLGFBQWEsQ0FBQyxFQUtqQjtRQUxpQixFQUNwQyxLQUFLLEVBQ0wsTUFBTSxFQUNOLEdBQUcsT0FFZ0IsRUFEaEIsS0FBSyxjQUo0QiwwQkFLckMsQ0FEUztJQUVSLE1BQU0sRUFBRSxVQUFVLEVBQUUsR0FBRyxJQUFBLDZCQUFvQixHQUFFLENBQUM7SUFFOUMsU0FBUyxTQUFTO1FBQ2hCLElBQUksTUFBTSxJQUFJLFVBQVUsS0FBSyxLQUFLLEVBQUU7WUFDbEMsT0FBTyxNQUFNLENBQUM7U0FDZjthQUFNLElBQUksS0FBSyxJQUFJLFVBQVUsS0FBSyxJQUFJLEVBQUU7WUFDdkMsT0FBTyxLQUFLLENBQUM7U0FDZDtRQUNELE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQyxjQUFjLEVBQUUsVUFBVSxDQUFDLENBQUM7SUFDakQsQ0FBQztJQUVELE9BQU8sOENBQUssR0FBRyxFQUFFLEdBQUcsZ0JBQWMsQ0FBQyxTQUFTLElBQUksU0FBUyxFQUFFLEVBQUUsSUFBTSxLQUFLLEVBQUksQ0FBQztBQUMvRSxDQUFDO0FBbEJELGdDQWtCQyJ9